import React from "react";

import airtable from "../../../assets/zap/airtable.png";
import bitrix24 from "../../../assets/zap/bitrix24.png";
import clickup from "../../../assets/zap/clickup.png";
import duxSoup from "../../../assets/zap/dux-soup.png";
import freshsales from "../../../assets/zap/freshsales.png";
import googleEmail from "../../../assets/zap/google-email.png";
import googleSheets from "../../../assets/zap/google-sheets.png";
import hubspot from "../../../assets/zap/hubspotcrm.png";
import infusionsoft from "../../../assets/zap/infusionsoft.png";
import insightly from "../../../assets/zap/insightly.png";
import instantly from "../../../assets/zap/instantly.png";
import lemlist from "../../../assets/zap/lemlist.png";
import mailchimp from "../../../assets/zap/mailchimp.png";
import dynamics365 from "../../../assets/zap/microsoft-dynamics-365-crm.png";
import microsoftEmail from "../../../assets/zap/microsoft-email.png";
import microsoftExcel from "../../../assets/zap/microsoft-excel.png";
import nutshell from "../../../assets/zap/nutshell.png";
import openai from "../../../assets/zap/openai-gpt-3.png";
import phantombuster from "../../../assets/zap/phantombuster.png";
import pipedrive from "../../../assets/zap/pipedrive.png";
import prosperworks from "../../../assets/zap/prosperworks.png";
import raynetcrm from "../../../assets/zap/raynetcrm.png";
import salesforce from "../../../assets/zap/salesforce.png";
import salesloft from "../../../assets/zap/salesloft.png";
import sendinblue from "../../../assets/zap/sendinblue.png";
import sugarcrm from "../../../assets/zap/sugarcrm11.png";
import typeform from "../../../assets/zap/typeform.png";
import vtiger from "../../../assets/zap/vtiger.png";
import woodpecker from "../../../assets/zap/woodpecker.png";
import zendesk from "../../../assets/zap/zendesk.png";
import zoho from "../../../assets/zap/zohocrm.png";
import all from "../../../assets/zap/all.png";
import Line from "../../../assets/line2.svg";
import { useNavigate } from "react-router-dom";

const logos = [
  { src: airtable, name: "Airtable", bgColor: "#18bfff" },
  { src: bitrix24, name: "Bitrix24", bgColor: "#0066a1" },
  { src: clickup, name: "ClickUp", bgColor: "#5f55ee" },
  { src: duxSoup, name: "Dux-Soup", bgColor: "#1cb2fa" },
  { src: freshsales, name: "Freshsales", bgColor: "#e57300" },
  { src: googleEmail, name: "Gmail", bgColor: "#dd4b39" },
  { src: googleSheets, name: "Google Sheets", bgColor: "#0fa763" },
  { src: hubspot, name: "HubSpot CRM", bgColor: "#ff7a59" },
  { src: infusionsoft, name: "Keap", bgColor: "#7abe43" },
  { src: insightly, name: "Insightly CRM", bgColor: "#ff4a00" },
  { src: instantly, name: "Instantly", bgColor: "#0073ff" },
  { src: lemlist, name: "Lemlist", bgColor: "#4242ff" },
  { src: mailchimp, name: "Mailchimp", bgColor: "#ffe01b" },
  { src: dynamics365, name: "Microsoft Dynamics 365", bgColor: "#00265f" },
  { src: microsoftEmail, name: "Microsoft Outlook", bgColor: "#006fc1" },
  { src: microsoftExcel, name: "Microsoft Excel", bgColor: "#1d6f42" },
  { src: nutshell, name: "Nutshell", bgColor: "#fe5900" },
  { src: openai, name: "OpenAI", bgColor: "#10a37f" },
  { src: phantombuster, name: "Phantom Buster", bgColor: "#252525" },
  { src: pipedrive, name: "Pipedrive CRM", bgColor: "#434a54" },
  { src: prosperworks, name: "Copper", bgColor: "#ff3364" },
  { src: raynetcrm, name: "Raynet CRM", bgColor: "#2eaec6" },
  { src: salesforce, name: "Salesforce", bgColor: "#019cdc" },
  { src: salesloft, name: "Salesloft", bgColor: "#05492d" },
  { src: sendinblue, name: "Brevo", bgColor: "#0b996e" },
  { src: sugarcrm, name: "SugarCRM", bgColor: "#02121a" },
  { src: typeform, name: "Typeform", bgColor: "#000000" },
  { src: vtiger, name: "Vtiger CRM", bgColor: "#4fcead" },
  { src: woodpecker, name: "Woodpecker", bgColor: "#060608" },
  { src: zendesk, name: "Zendesk", bgColor: "#02363c" },
  { src: zoho, name: "Zoho CRM", bgColor: "#4990e2" },
  { src: all, name: "View all apps", bgColor: "#a3a7b6" },
];

export default function LogoGrid() {
  const navigate = useNavigate();
  return (
    <>
      <h2 className="text-3xl pt-8 sm:text-4xl lg:text-[48px] lg:leading-[3.75rem] font-bold text-center py-10">
        Powered by Zapier • Connect &{" "}
        <span className="relative inline-block">
          Automate{" "}
          <img
            src={Line}
            alt="Underline decoration"
            className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
          />
        </span>{" "}
      </h2>
      <div className="mx-auto mt-4 px-6 md:px-12 flex flex-col md:flex-row items-center md:justify-center md:items-center md:space-x-8 h-full">
        <div className="text-center md:text-left md:w-1/2">
          <h2 className="text-3xl text-[#15223F] md:text-4xl lg:text-[2.5rem] lg:leading-[3rem] font-bold">
            Seamless Automation with{" "}
            <span className="relative inline-block">
              Zapier
              <img
                src={Line}
                alt="Underline decoration"
                className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
              />
            </span>{" "}
            Integration
          </h2>
          <p className="text-xl md:text-[22px] mt-7 mb-4">
            Connect ExactMails with over 5,000+ apps effortlessly using Zapier.
            Automate your workflows and eliminate repetitive tasks with ease.
          </p>
          <p className="text-xl md:text-[22px] my-4">
            Whether you're syncing emails with CRMs or triggering follow-ups,
            Zapier ensures smooth automation without any coding required.
          </p>
          <p className="text-xl md:text-[22px] my-4">
            Stay productive and scale your business faster with real-time email
            discovery integrated directly into your favorite tools.
          </p>
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-4 p-4 md:w-1/2 max-h-[440px] scrollbar-hide overflow-auto">
          {logos.map((logo, index) => (
            <div key={index} className="flex flex-col items-center space-y-2">
              <div
                className="w-16 h-16 cursor-pointer flex items-center justify-center rounded-lg shadow-md"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("/zapier");
                }}
                style={{ backgroundColor: logo.bgColor }}
              >
                <img
                  src={logo.src}
                  alt={logo.name}
                  className="w-10 h-10 object-contain"
                />
              </div>
              <p className="text-gray-600 font-semibold text-xs text-center">
                {logo.name}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="text-center w-full flex justify-center mt-8 md:mt-14 mb-20">
        <button
          onClick={() => {
            window.scrollTo(0, 0);
            navigate("/zapier");
          }}
          className="text-white font-semibold p-3 rounded-md bg-background hover:bg-hover hover:text-white w-[220px]"
        >
          View All Apps
        </button>
      </div>
    </>
  );
}
